<template>
  <b-modal
    id="update-complete-service-system-modal"
    cancel-variant="outline-secondary"
    :ok-title="$t('button.confirm')"
    :cancel-title="$t('button.close')"
    centered
    :title="$t('breadcrumb.updateServiceSystem')"
    no-close-on-backdrop
    :loading="loading"
    @ok="handleOk"
    @cancel="handleClose"
    @close="handleClose"
  >
    <template #modal-footer>
      <b-button
        variant="outline-secondary"
        class="btn"
        @click="handleClose"
      >
        {{ $t('button.close') }}
      </b-button>
      <n-button-loading
        :loading="loading"
        class="btn"
        variant="primary"
        :disabled="isUploading"
        @submit="handleOk"
      >
        {{ $t('button.confirm') }}
      </n-button-loading>
    </template>
    <validation-observer ref="updateCompleteServiceSystemForm">
      <!-- <label class="d-block">
        <span>{{ $t('field.servicePrice') }}</span>
      </label>
      <div
        class="d-flex"
        style="gap: 10px"
      >
        <validation-provider
          v-slot="{ errors }"
          :rules="rules"
          :name="$t('field.servicePrice')"
          class="flex-grow-1"
        >
          <b-form-group>
            <b-form-input
              v-model="data.servicePrice"
              type="number"
              :placeholder="$t('field.servicePrice')"
              :name="$t('field.servicePrice')"
              autocomplete="off"
              :disabled="activeChannel.servicePriceType === 1"
              :class="errors.length > 0 ? 'is-invalid' : null"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </b-form-group>
        </validation-provider>
        <b-form-group style="min-width: 100px">
          <n-single-select
            :key="activeChannel.id"
            v-model="activeChannel.servicePriceCurrency"
            :options="[
              { value: 'CNY', name: 'CNY' },
              { value: 'USD', name: 'USD' },
              { value: 'KHR', name: 'KHR' },
              { value: 'VND', name: 'VND' }
            ]"
            value="CNY"
            selection-key="value"
            selection-label="name"
            :reduce="true"
            :readonly="activeChannel.servicePriceType !== 3"
          />
        </b-form-group>
      </div> -->

      <n-input
        v-model="data"
        :fields="formInput"
      >
        <template #remarkMedia>
          <b-form-group>
            <label>
              <span>{{ $t('field.file') }}</span>
              <span class="text-muted"> - {{ $t('field.optional') }} </span>
            </label>
            <n-multiple-file-uploader
              v-model="data.remarkMedia"
              class="mb-1"
              @media-ids="updateRemarkMediaIds"
              @uploading="onUploading"
            />
          </b-form-group>
        </template>
      </n-input>
    </validation-observer>
  </b-modal>
</template>

<script>
import {
  BModal, BButton, BFormGroup, BFormInput,
} from 'bootstrap-vue'
import NInput from '@/components/NInput.vue'
import useJwt from '@/auth/jwt/useJwt'
import NButtonLoading from '@/components/NButtonLoading.vue'
import NMultipleFileUploader from '@/components/NMultipleFileUploader.vue'
import NSingleSelect from '@/components/NSingleSelect.vue'
import FormInput from './updateServiceSystemCompleteStatusFormInput'

export default {
  components: {
    BModal,
    NInput,
    BButton,
    NButtonLoading,
    NMultipleFileUploader,
    BFormGroup,
    BFormInput,
    NSingleSelect,
  },
  props: {
    activeRoom: {
      type: Object,
      required: false,
      default() {
        return {}
      },
    },
    loading: {
      type: Boolean,
      default: false,
    },
    activeChannel: {
      type: Object,
      required: false,
      default() {
        return {}
      },
    },
  },
  data() {
    return {
      data: {
        remark: '',
        remarkMediaIds: [],
        servicePrice: null,
      },
      key: 1,
      isUploading: false,
    }
  },
  computed: {
    userData() {
      return this.$store.state.profile.email || this.$store.state.profile.phone
        ? this.$store.state.profile
        : JSON.parse(
          localStorage.getItem(useJwt.jwtConfig.storageUserDataKeyName),
        )
    },
    rules() {
      return this.activeChannel.servicePriceType === 3
        ? 'required|numeric'
        : `required|numeric|min_value:${this.activeChannel.servicePriceMin}|max_value:${this.activeChannel.servicePriceMax}`
    },
  },
  watch: {
    activeChannel: {
      handler() {
        this.data.remarkMediaIds = []
        if (this.activeChannel.servicePriceType === 1) {
          this.data.servicePrice = this.activeChannel.servicePriceMin
        } else {
          // this.data.servicePrice = null;
        }
      },
      deep: true,
    },
  },
  methods: {
    show(remark) {
      this.key += 1
      this.data.remark = remark
      // if (this.activeChannel.servicePriceType !== 1) {
      //   this.data.servicePrice = null
      // } else {
      //   this.data.servicePrice = this.activeChannel.servicePriceMin
      // }
      this.$bvModal.show('update-complete-service-system-modal')
    },
    hide() {
      this.$bvModal.hide('update-complete-service-system-modal')
    },
    handleOk() {
      this.$refs.updateCompleteServiceSystemForm.validate().then(success => {
        if (success) {
          this.submit()
        }
      })
    },
    submit() {
      this.$emit('update',
        {
          remark: this.data.remark,
          remarkMediaIds: this.data.remarkMediaIds,
          servicePrice: this.data.servicePrice,
          status: this.activeChannel.status === 'processing' ? 'pendingPrice' : 'completed',
        })
    },
    updateRemarkMediaIds(mediaIds) {
      this.data.remarkMediaIds = mediaIds
    },
    onUploading(value) {
      this.isUploading = value
    },
    handleClose() {
      this.hide()
      // this.activeChannel.servicePriceCurrency = 'CNY'
      this.data.servicePrice = null
      this.data.remarkMediaIds = []
      this.data.remark = ''
      this.$emit('cancel')
    },
  },
  setup() {
    const formInput = [...FormInput]

    return {
      formInput,
    }
  },
}
</script>

<style lang="scss">
  @import '@core/scss/vue/libs/vue-select.scss';

  .s-container {
    position: relative;
  }

  .price {
    position: absolute;
    right: 1.575rem;
    top: 3.425rem;
    padding: 0.375rem 0.75rem;
    background-color: #f8f9fa;
    border: 1px solid #ced4da;
    border-radius: 0.25rem;
    z-index: 10;
  }
</style>
